export function debounce(callback, execOnLeadingEdge = false, debounceDelay = 200) {
    let timeout;

    return function debounced() {
        let obj = this;
        let args = arguments;

        function delayed() {
            if (!execOnLeadingEdge) {
                callback.apply(obj, args);
            }
            timeout = null;
        }

        if (timeout) {
            clearTimeout(timeout);
        } else if (execOnLeadingEdge) {
            callback.apply(obj, args);
        }

        timeout = setTimeout(delayed, debounceDelay);
    };
}